module.exports = __webpack_public_path__ + "img/4_m.7dde41bf.jpg";